module.exports = __webpack_public_path__ + "static/media/category2.706ed71b.png";